import { useTheme } from '@emotion/react';

import { type MOOD_STATES, MOODS } from '../constants';
import * as styles from '../MoodBox.styles';
import { faceIllustrationColorMap } from '../MoodBox.styles';

type PositiveMoodProps = {
  state: MOOD_STATES;
};

export const PositiveMood = ({ state }: PositiveMoodProps) => {
  const theme = useTheme();

  const color = faceIllustrationColorMap(MOODS.POSITIVE, state, theme);

  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      css={styles.positiveMood}
    >
      <path
        d="M11.2733 10.4698C11.5697 9.87699 11.3294 9.15618 10.7367 8.85979C10.1439 8.56341 9.42307 8.80368 9.12668 9.39645L9.08048 9.48003C8.97017 9.66449 8.75246 9.94759 8.42776 10.2362C7.79358 10.7999 7.00228 11.1331 5.99999 11.1331C4.99771 11.1331 4.20641 10.7999 3.57223 10.2362C3.19341 9.89948 2.96022 9.57028 2.87331 9.39645L2.8035 9.27489C2.4746 8.77209 1.81377 8.58458 1.26334 8.85979C0.670564 9.15618 0.430295 9.87699 0.726682 10.4698C0.939765 10.8959 1.34408 11.4667 1.97776 12.03C3.03108 12.9663 4.37728 13.5331 5.99999 13.5331C7.62271 13.5331 8.96891 12.9663 10.0222 12.03C10.6559 11.4667 11.0602 10.8959 11.2733 10.4698Z"
        fill={color}
      />
      <path
        d="M11.3919 1.99316C11.3226 1.39635 10.8154 0.933105 10.2 0.933105C9.53725 0.933105 8.99999 1.47036 8.99999 2.13311V4.53311L9.00807 4.67305C9.07739 5.26986 9.58459 5.73311 10.2 5.73311C10.8627 5.73311 11.4 5.19585 11.4 4.53311V2.13311L11.3919 1.99316Z"
        fill={color}
      />
      <path
        d="M2.99192 1.99316C2.9226 1.39635 2.4154 0.933105 1.79999 0.933105C1.13725 0.933105 0.599994 1.47036 0.599994 2.13311V4.53311L0.608068 4.67305C0.677386 5.26986 1.18459 5.73311 1.79999 5.73311C2.46274 5.73311 2.99999 5.19585 2.99999 4.53311V2.13311L2.99192 1.99316Z"
        fill={color}
      />
    </svg>
  );
};
